import { AccordionPropertiesType } from "@website/website-ui/accordion/accordion.types";
import { MouseEvent, useCallback, useEffect, useRef, useState } from "react";

export const useAccordionItem = (properties: AccordionPropertiesType) => {
  const contentReference = useRef(null);
  const { disabled, initialExpanded } = properties;
  const [expanded, setExpanded] = useState<boolean>(initialExpanded ?? false);
  const [height, setHeight] = useState<"auto" | number>("auto");

  const onDetailsClick = useCallback(
    (event: MouseEvent<HTMLDetailsElement>) => {
      event.preventDefault();

      if (!disabled) {
        setExpanded((state) => !state);
      }
    },
    [disabled]
  );

  useEffect(() => {
    if (expanded && contentReference.current) {
      setHeight(contentReference.current["scrollHeight"]);
    } else {
      setHeight(0);
    }
  }, [expanded]);

  return {
    expanded,
    detailsProperties: {
      open: expanded
    },
    summeryProperties: {
      onClick: onDetailsClick
    },
    buttonProperties: {
      "aria-label": expanded ? "collapse" : "expand",
      disabled: disabled
    },
    contentWrapperProperties: {
      ref: contentReference,
      style: {
        height
      }
    }
  };
};
